import {
    ADAPTIVE_BREAKPOINT,
    ADAPTIVE_MODE,
} from '../constants';

import {
    getLsManualAdaptiveMode,
} from './getLsManualAdaptiveMode';

export function getInnerWidth(): number {
    const mode = getLsManualAdaptiveMode();

    // К результату добавляем значение вверх, чтобы избежать неточностей в условиях
    switch (mode) {
        case ADAPTIVE_MODE.MOBILE: {
            return ADAPTIVE_BREAKPOINT.W320 + 10;
        }
        case ADAPTIVE_MODE.DESKTOP: {
            return ADAPTIVE_BREAKPOINT.W1024 + 10;
        }
        case null: {
            return window.innerWidth;
        }
    }
}
